module.exports = __webpack_public_path__ + "static/img/banner.eae50856.png";